export const translations = {
    MISSING_VALUE: 'Veuillez sélectionner une option',
};
